/**
 * Routes.
 * @module routes
 */

import { defaultRoutes } from '@plone/volto/routes';
import config from '@plone/volto/registry';
import { AuthorView } from '~/components';
import PortraitManager from './components/PortraitManager/PortraitManager';

/**
 * Routes array.
 * @array
 * @returns {array} Routes.
 */
const routes = [
  {
    path: '/',
    component: config.getComponent('App').component,
    routes: [
      // Add your routes here
      {
        path: '/author/:author_id',
        component: AuthorView,
        exact: true,
      },
      {
        path: '/portrait-manager',
        component: PortraitManager,
        exact: true,
        isRootRoute: true, // This prevents Volto from trying to fetch content
      },
      ...(config.addonRoutes || []),
      ...defaultRoutes,
    ],
  },
];

export default routes;
